import { useMemo } from 'react';

import { useBreakPoints } from 'core';
import { Outlet, useLocation, useMatch, useNavigate } from 'react-router-dom';
import { SegmentedControl } from 'ui';

const WalletLayout = () => {
  const { isSmallScreen } = useBreakPoints();
  const navigate = useNavigate();
  const isNativeRoute = useMatch('/native/*');
  const location = useLocation();
  const blacklistRoutes = ['/wallet/events/'];

  const showTabs =
    isSmallScreen &&
    !isNativeRoute &&
    !blacklistRoutes.some((route) => location.pathname.includes(route));

  const isWallet = useMatch('/wallet/wallet/*');
  const isEarnings = useMatch('/wallet/earnings/*');
  const isPurchases = useMatch('/wallet/purchases/*');

  const walletTabValue = useMemo(() => {
    if (isWallet) return 'wallet';
    if (isEarnings) return 'earnings';
    if (isPurchases) return 'purchases';
    return 'wallet';
  }, [isEarnings, isPurchases, isWallet]);

  const WalletLayoutTabs = useMemo(
    () => [
      { label: 'Wallet', value: 'wallet' },
      {
        label: 'Earnings',
        value: 'earnings',
      },
      {
        label: 'Purchases',
        value: 'purchases',
      },
    ],

    []
  );

  return (
    <>
      {showTabs && (
        <SegmentedControl
          fullWidth
          value={walletTabValue}
          data={WalletLayoutTabs}
          onChange={(value) => navigate(`${value}`)}
          variant="light"
          withItemsBorders={false}
          size="sm"
          mb="lg"
        />
      )}
      <Outlet />
    </>
  );
};

export { WalletLayout };
